import { render, staticRenderFns } from "./KeywordsErrors.vue?vue&type=template&id=57586126"
import script from "./KeywordsErrors.vue?vue&type=script&lang=js"
export * from "./KeywordsErrors.vue?vue&type=script&lang=js"
import style0 from "./KeywordsErrors.vue?vue&type=style&index=0&id=57586126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports